/**
 * TipTap Custom Node: PaperlessDocLink
 *
 * Inline Chip/Badge der auf ein Paperless-Dokument verweist.
 * Klick öffnet das PDF im Viewer.
 */

import { Node, mergeAttributes } from '@tiptap/core'

export interface PaperlessDocLinkOptions {
  onDocClick?: (docId: number, title: string) => void
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    paperlessDocLink: {
      insertPaperlessDocLink: (attrs: { docId: number; title: string; fileName?: string }) => ReturnType
    }
  }
}

export const PaperlessDocLinkNode = Node.create<PaperlessDocLinkOptions>({
  name: 'paperlessDocLink',
  group: 'block',
  atom: true,
  // draggable wird NICHT gesetzt — eigenes Drag-System in EmbedDragPlugin.ts

  addOptions() {
    return { onDocClick: undefined }
  },

  addAttributes() {
    return {
      docId: {
        default: null,
        parseHTML: el => Number(el.getAttribute('data-doc-id')),
        renderHTML: attrs => ({ 'data-doc-id': attrs.docId }),
      },
      title: {
        default: 'Dokument',
        parseHTML: el => el.getAttribute('data-title'),
        renderHTML: attrs => ({ 'data-title': attrs.title }),
      },
      fileName: {
        default: '',
        parseHTML: el => el.getAttribute('data-file-name'),
        renderHTML: attrs => ({ 'data-file-name': attrs.fileName }),
      },
    }
  },

  parseHTML() {
    return [
      { tag: 'div[data-type="paperless-doc-link"]' },
      { tag: 'span[data-type="paperless-doc-link"]' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'paperless-doc-link',
        class: 'paperless-doc-link-chip',
        contenteditable: 'false',
      }),
      HTMLAttributes['data-title'] ?? 'Dokument',
    ]
  },

  addCommands() {
    return {
      insertPaperlessDocLink:
        attrs =>
        ({ commands }) => {
          return commands.insertContent({ type: this.name, attrs })
        },
    }
  },
})
